import type { RequestResponse } from '@/types/publicType'
import type {
  userStateListInterface,
  configureInterface
} from '@/types/apiType/chatType'

/**
 * 获取回会话列表状态
 * @param {string} uidList // 123,123,123
 */
export function apiGetStateList(data: {
  uidList: string
}): Promise<RequestResponse<userStateListInterface[]>> {
  return getFetchData({
    url: '/h5/c/state/list',
    method: 'POST',
    data
  })
}

/**
 * H5端男用户上/下线 type
 * @param { 1 | 2 } type // 1上线 2下线
 */
export function apiManOnline(data: {
  type: 1 | 2
  uid: number | string
}): Promise<RequestResponse<void>> {
  return getFetchData({
    url: '/h5/u/h5ManOnline',
    method: 'POST',
    data
  })
}

/**
 * 检查用户会话限制情况
 * freeCount 剩余免费次数
 * limitLv 限制等级 10
 * sendPic 是否可发图片
 * @param {number | string} tuid // 对方id
 */
export function apiGetConfigure(): Promise<
  RequestResponse<configureInterface>
> {
  return getFetchData({
    url: '/client/web/configure',
    method: 'GET'
  })
}

/**
 * 翻译
 * @param {string} text // 文本
 */
export function apiTranslate(params: {
  text: string
}): Promise<RequestResponse<string>> {
  return getFetchData({
    url: 'advertise/translate',
    method: 'GET',
    params
  })
}
